module.exports = __webpack_public_path__ + "img/emoji/pepekms.6b68e14543c2065b6275eb17f287b5fe.png";